import { Handler } from '../../helpers/typeHelper'
import { EsignEnvelopeVendor } from '../../models/esign'
import { useUserProvider } from '../Context/UserContext'
import { Back } from '../Nav/Back'
import { Text } from '../Text/Text'
import { DocusignEnvelope } from './DocusignEnvelope'
import { DropboxSignEnvelope } from './DropboxSignEnvelope'
import { EsignFullScreenWrap } from './EsignFullScreenWrap'

interface EsignProps {
  url: string
  title: React.ReactNode
  onSign: Handler
  onBack?: Handler
  vendorKey: string
  vendor: EsignEnvelopeVendor
}

export function Esign({ title, url, onSign, onBack, vendorKey, vendor }: EsignProps) {
  const { showBanner } = useUserProvider()

  function handleBack() {
    ;(window as any).dropboxSignClient?.close?.()
    onBack?.()
  }

  function renderEnvelope() {
    if (vendor === EsignEnvelopeVendor.DOCUSIGN) {
      return (
        <DocusignEnvelope
          url={url}
          integrationKey={vendorKey}
          onAgree={onSign}
          onError={() => showBanner('error', { message: 'Something went wrong. Please try again.' })}
          isOpen
        />
      )
    }
    if (vendor === EsignEnvelopeVendor.DROPBOX) {
      return (
        <DropboxSignEnvelope
          url={url}
          integrationKey={vendorKey}
          onAgree={onSign}
          onError={() => showBanner('error', { message: 'Something went wrong. Please try again.' })}
        />
      )
    }
    return null
  }

  return (
    <EsignFullScreenWrap
      title={
        <Text variant="header1" align="center" mb={2}>
          {title}
        </Text>
      }
    >
      {onBack && <Back onClick={handleBack} />}
      {renderEnvelope()}
    </EsignFullScreenWrap>
  )
}
